import type { AmplifyKeys } from "@observe-tech/utils";
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";

const KEY_PREFIX = "CognitoIdentityServiceProvider";

export function amplifyClientId(): string {
  return import.meta.env.VITE_AWS_CLIENT_ID ?? "";
}

export function captureAmplifyKeys(clientId: string): AmplifyKeys | null {
  try {
    const lastAuthUserKey = `${KEY_PREFIX}.${clientId}.LastAuthUser`;
    const lastAuthUser = localStorage.getItem(lastAuthUserKey);
    if (!lastAuthUser) return null;
    const userPrefix = `${KEY_PREFIX}.${clientId}.${lastAuthUser}.`;
    const keys: AmplifyKeys = { [lastAuthUserKey]: lastAuthUser };
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key?.startsWith(userPrefix)) continue;
      const value = localStorage.getItem(key);
      if (value !== null) keys[key] = value;
    }
    return keys[`${userPrefix}refreshToken`] ? keys : null;
  } catch {
    return null;
  }
}

export function restoreAmplifyKeys(keys: AmplifyKeys): void {
  try {
    for (const [key, value] of Object.entries(keys)) {
      localStorage.setItem(key, value);
    }
  } catch (error) {
    console.warn("[amplifyKeys] restore failed", error);
  }
}

export function refreshTokenOf(keys: AmplifyKeys): string | null {
  const entry = Object.entries(keys).find(([key]) =>
    key.endsWith(".refreshToken"),
  );
  return entry?.[1] || null;
}

export async function clearAmplifyKeysLocally(): Promise<void> {
  try {
    await cognitoUserPoolsTokenProvider.tokenOrchestrator.clearTokens();
  } catch (error) {
    console.warn("[amplifyKeys] clearTokens failed", error);
  }
}
